import type { IValidatedResponse } from '../../httpClient';
import { postRequest } from '../../httpClient';
import type { IIdAckResponse } from '../ack-schema';
import { idAckResponseSchema } from '../ack-schema';
import type { IPersonCreditBody } from '../credit-body-schema';

export async function addPersonCreditApi(
  personId: number,
  body: IPersonCreditBody,
): Promise<IValidatedResponse<IIdAckResponse>> {
  return postRequest<IIdAckResponse>({
    path: `/sys/people/v1/${personId}/credits`,
    body,
    schema: idAckResponseSchema,
  });
}
